import { useState } from 'react';
import { cn } from '@/lib/utils';
import { resolveApiMediaUrl } from '@/lib/media';
import { productGalleryStyles } from './ProductGallery.styles';

export type ProductGalleryImage = {
  url: string;
  alt?: string;
};

export type ProductGalleryProps = {
  images: ProductGalleryImage[];
  productName: string;
  className?: string;
};

export function ProductGallery({
  images,
  productName,
  className,
}: ProductGalleryProps): JSX.Element {
  const list = images.length > 0 ? images : [{ url: '', alt: productName }];
  const [active, setActive] = useState(0);
  const current = list[Math.min(active, list.length - 1)] ?? list[0];
  const currentUrl = resolveApiMediaUrl(current.url);
  const showThumbs = list.length > 1;

  return (
    <div className={cn(productGalleryStyles.root, className)}>
      <div className={productGalleryStyles.main}>
        {currentUrl ? (
          <img
            src={currentUrl}
            alt={current.alt || productName}
            className={productGalleryStyles.mainImg}
          />
        ) : (
          <div className="flex h-full w-full items-center justify-center font-sans text-sm text-brand-700">
            {productName}
          </div>
        )}
      </div>
      {showThumbs ? (
        <div className={productGalleryStyles.thumbs} role="list">
          {list.map((img, index) => (
            <button
              key={`${img.url}-${index}`}
              type="button"
              role="listitem"
              aria-label={`${productName} ${index + 1}`}
              aria-current={index === active ? 'true' : undefined}
              className={cn(
                productGalleryStyles.thumb,
                index === active && productGalleryStyles.thumbActive,
              )}
              onClick={() => setActive(index)}
            >
              <img
                src={resolveApiMediaUrl(img.url) ?? ''}
                alt=""
                className={productGalleryStyles.thumbImg}
              />
            </button>
          ))}
        </div>
      ) : null}
    </div>
  );
}
